import React, { useCallback } from 'react';
import './VenueAnalysis.scss';
import styleConstants from 'styles/variables.module.scss';

import VenueAnalysisToolbar from './toolbar/VenueAnalysisToolbar';
import { getVenueAnalysisData } from './venueAnalysisAggregatedData';
import VenueAnalysisGrid from './grid/VenueAnalysisGrid';

import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { VenueAnalysisSelection } from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';
import { useWidgetContext } from 'widgets/WidgetContext';
import { venueAnalysisStreamedDataSelectors } from 'widgets/venueAnalysis/store/stream/streamSlice';
import { useVenueAnalysisConfigSlice } from 'widgets/venueAnalysis/store/configuration/configSlice';
import { useVenueAnalysisComponentSlice } from 'widgets/venueAnalysis/store/component/componentSlice';

const padding = 2 * parseInt(styleConstants.spaceAround);
const toolbarHeight = parseInt(styleConstants.panelHeaderHeight);
const borderWidth = 2 * parseInt(styleConstants.layoutBorderWidth);

export default function VenueAnalysis() {
    const { widgetKey, height, width } = useWidgetContext();

    useWidgetStream();

    const { useWidgetStreamData } = venueAnalysisStreamedDataSelectors;

    const streamData = useWidgetStreamData();
    const { component, dispatchComponentChanged: updateComponent } =
        useVenueAnalysisComponentSlice();

    const { config, dispatchConfigChanged: updateConfig } =
        useVenueAnalysisConfigSlice();

    const data = getVenueAnalysisData(
        streamData,
        component.selection,
        config.includePreviousDaysFills
    );

    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();

    const { hideToolbar } = config;

    const toolbarConsumedHeight = hideToolbar ? 0 : toolbarHeight;

    const gridHeight = hideToolbar
        ? height - borderWidth - padding
        : height - toolbarConsumedHeight - borderWidth - padding;

    const changeSelection = useCallback(
        (selection?: VenueAnalysisSelection) => {
            updateComponent({ selection });
        },
        [updateComponent]
    );

    return (
        <div className="VenueAnalysis" data-widget-id={widgetKey}>
            <VenueAnalysisToolbar
                data={data}
                selection={component.selection}
                onChangeSelection={changeSelection}
            />

            {hasValidSelection && (
                <VenueAnalysisGrid
                    data={data}
                    config={config}
                    onConfigChange={updateConfig}
                    selection={component.selection}
                    onChangeSelection={changeSelection}
                    widgetKey={widgetKey}
                    height={gridHeight}
                    width={width}
                />
            )}
        </div>
    );
}
